import { mapModelToDto, mapDtoToModel } from './mappers';

export { resourceTypeService } from './resources-type-service';
export const ResourceTypeMappers = { mapModelToDto, mapDtoToModel };
export type { ResourceTypeDto } from './types';
